import client from '@/services/client'
import type {
  IBusLogsListResponse,
  ICommandBusLog,
  ICommandBusLogsFilters,
  IIntegrationActionLogDetail,
  ILogsFilters,
  ILogsListResponse,
  IQueryBusLog,
  IQueryBusLogsFilters,
  LabeledEnum,
} from '@/types/LogTypes'

import type { AxiosResponse } from 'axios'

const getActionTypes = async (): Promise<AxiosResponse<LabeledEnum[]>> =>
  client.get('/logs/integrations/action-types')

const getLogs = async (
  params?: ILogsFilters
): Promise<AxiosResponse<ILogsListResponse>> =>
  client.get('/logs/integrations', { params })

const getLog = async (
  uuid: string
): Promise<AxiosResponse<{ data: IIntegrationActionLogDetail }>> =>
  client.get(`/logs/integrations/${uuid}`)

const exportLogs = async (
  params?: ILogsFilters
): Promise<AxiosResponse<Blob>> =>
  client.get('/logs/integrations/export', {
    params,
    responseType: 'blob',
  })

export const LogsRepository = {
  getActionTypes,
  getLogs,
  getLog,
  exportLogs,
}

const getCommandBusLogs = async (
  params?: ICommandBusLogsFilters
): Promise<AxiosResponse<IBusLogsListResponse<ICommandBusLog>>> =>
  client.get('/logs/command-bus', { params })

const getCommandBusKeys = async (): Promise<AxiosResponse<LabeledEnum[]>> =>
  client.get('/logs/command-bus/keys')

const getQueryBusLogs = async (
  params?: IQueryBusLogsFilters
): Promise<AxiosResponse<IBusLogsListResponse<IQueryBusLog>>> =>
  client.get('/logs/query-bus', { params })

const getQueryBusKeys = async (): Promise<AxiosResponse<LabeledEnum[]>> =>
  client.get('/logs/query-bus/keys')

export const BusLogsRepository = {
  getCommandBusLogs,
  getCommandBusKeys,
  getQueryBusLogs,
  getQueryBusKeys,
}

export const busLogsPermissions = {
  VIEW_ANY: 'logs.bus.viewAny',
} as const
